<template v-once>
  <img src="@/assets/icons/equals5_icon.png" alt="equals5 icon">
</template>

<script>
export default {
  name: "Equals5",
};
</script>

<style scoped>
</style>